import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataDepartment } from '../types/masterdata-entities';
import { keyName } from './shared';

export const MASTERDATA_DEPARTMENT = defineMasterdataEntity<MasterdataDepartment>({
  name: 'department',
  responseKey: 'departments',
  displayWith: (d) => keyName(d.key, d.name),
  icon: 'fa-regular fa-sitemap',
  title: 'Abteilungssuche',
  label: 'Abteilung',
  placeholder: 'Abteilung suchen...',
  columns: [
    {
      label: 'Abteilung',
      type: 'entity',
      icon: 'fa-regular fa-sitemap',
      value: (d) => keyName(d.key, d.name),
    },
    { label: 'Schlüssel', type: 'text', value: (d) => d.key },
    { label: 'Bezeichnung', type: 'text', value: (d) => d.name },
    { label: 'Aktiv', type: 'text', value: (d) => (d.active ? 'Ja' : 'Nein') },
  ],
});
